<template>
    <div class="containerr">
        <div class="hero nunito">
            <div class="flex-1 heroLeft">
                <h1 class="heroTitle">Sorry, <span>page not found</span></h1>
                <span class="hero-subTitle">Try another page and feature!</span>
                <router-link to="/">Let's Go!</router-link>
            </div>
            <div class="flex-1 heroRight">
                <img src="../assets/no-results.webp" alt="">
            </div>
        </div>
    </div>
</template>